import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * @usageNotes
 * ```typescript
 * await bootstrapApplication(RootComponent, {
 *   providers: [
 *     provideHttpClient(
 *       withInterceptors([jsonLdInterceptor, authInterceptor])
 *     ),
 *   ]
 * });
 * ```
 */
export function jsonLdInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  let update = req.headers;
  if (!req.headers.has('accept') && req.method !== 'JSONP') {
    update = req.headers.set('accept', 'application/ld+json, application/json');
  }
  const request: HttpRequest<unknown> = req.clone({ headers: update });
  return next(request);
}
